module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" preserveAspectRatio=\"xMaxYMax meet\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#155724\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.67 7.99l2.64 2.2L11.94 6\"/><circle cx=\"8\" cy=\"8\" r=\"7.5\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/check-circle-dark-green-chunky.svg
// module id = lh3x
// module chunks = 5